import { request } from './client';

export type Settings = {
	// Email
	email_sender_name: string;
	email_sender_email: string;
	notify_welcome_client: boolean;
	notify_new_booking_confirmation: boolean;
	notify_new_booking_alert: boolean;
	notify_cancellation_notice: boolean;
	notify_24_hour_reminder: boolean;
	notify_order_confirmed: boolean;
	notify_order_cancelled: boolean;
	notify_session_booking_confirmation: boolean;
	notify_session_completed_follow_up: boolean;
	notify_session_cancelled_alert: boolean;
	// Payment
	currency: string;
	payment_offline_enabled: boolean;
	payment_offline_title: string;
	payment_offline_description: string;
	// Google
	google_client_id: string;
	google_client_secret: string;
	google_meet_enabled: boolean;
};

export const settingsApi = {
	get: () => request<Settings>('/settings'),
	update: (data: Partial<Settings>) =>
		request<Settings>('/settings', { method: 'PATCH', data }),
};
